
const Color = require('color')


export const  setPrimaryColor = (color) => setColor('primary-color', color)
export const setSecondaryColor = (color) => setColor('secondary-color', color)
const changeCssVar = (varName, value) =>
    document.documentElement.style.setProperty(`--${varName}`, value )


function setColor(cssVarName, color) {
    const saturate = Color(color).saturate(0.7).lighten(.25)
    let inverted = Color(color).lighten(.5)

    if (Color(color).isLight())
        inverted = Color(color).darken(.5)

    changeCssVar(cssVarName, color)
    changeCssVar(cssVarName+'-less-dark', Color(color).darken(.2))
    changeCssVar(cssVarName+'-dark', Color(color).darken(.5))
    changeCssVar(cssVarName+'-more-dark', Color(color).darken(.65))
    changeCssVar(cssVarName+'-light', Color(color).lighten(.5))
    changeCssVar(cssVarName+'-inverted' , inverted)
    changeCssVar(cssVarName+'-saturated' , saturate)
    changeCssVar(cssVarName+'-button-text' , saturate.luminosity() > .76 ? '#555555' : '#fff'  )
}















// WEBPACK FOOTER //
// ./src/helpers/theme.js